import React, { useEffect, useState } from "react";
import axios from "axios";
import swal from 'sweetalert';
import { Link, useNavigate } from "react-router-dom";

import { Col, Row ,Dropdown} from 'react-bootstrap';
export default function OpeningBalanceModal() {
  const navigate = useNavigate(); // Use useNavigate hook for navigation

 ///////////////////////////////////////////////////////////
   const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
   function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'OpeningBalances';
  const actionsForPage = getActionsForPage(pageName);

///////////////////////////////////


  const [accounts, setAccounts] = useState([]);
  const [balances, setBalances] = useState([]);
   const userdata = localStorage.getItem('USER_data');
    const userData = JSON.parse(userdata);
    const userid = userData.id;
  const [formData, setFormData] = useState({
    account_id: "",
    counter_account_id: "",
    amount: "",
    description: "",
    UserID:userid
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  
 useEffect(() => {
      if (userid) {
        setFormData((prevData) => ({
          ...prevData,
           UserID: userid,
        }));
      }
    }, [ userid]);
  useEffect(() => {
    axios.get("https://subk.education.com.ly/back/api/accounts").then((res) => {
      setAccounts(res.data);
    });
    fetchBalances();
  }, []);

  const fetchBalances = () => {
    axios.get("https://subk.education.com.ly/back/api/openingbalances").then((res) => {
      setBalances(res.data);
    });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await axios.post(
        "https://subk.education.com.ly/back/api/openingbalances",
        formData
      );
      swal(res.data.message);
      setFormData({
        account_id: "",
        counter_account_id: "",
        amount: "",
        description: "",
            UserID:userid

      });
      fetchBalances();
    } catch (err) {
      setMessage(err.response?.data?.message || "حدث خطأ أثناء الإضافة");
    }

    setLoading(false);
  };
// أعلى الكود بعد تعريف useState و useEffect
const [posting, setPosting] = useState(false);

// const handlePostOpeningBalances = async () => {
//   if (!window.confirm("هل أنت متأكد؟ هذه العملية تنفذ مرة واحدة فقط!")) return;

//   setPosting(true);
//   try {
//     const res = await axios.post("https://subk.education.com.ly/back/api/postopeningbalances");
//     swal(res.data.message);
//     fetchBalances(); // لتحديث الجدول بعد الترحيل
//   } catch (err) {
//     swal(err.response?.data?.message || "حدث خطأ أثناء الترحيل");
//   }
//   setPosting(false);
// };
const handlePostOpeningBalances = async () => {
  if (!window.confirm("هل أنت متأكد؟ هذه العملية تنفذ مرة واحدة فقط!")) return;

  setPosting(true);
  try {
    const res = await axios.post(
      "https://subk.education.com.ly/back/api/postopeningbalances",
      { UserID: userid } // إرسال UserID هنا
    );
    swal(res.data.message);
    fetchBalances(); // لتحديث الجدول بعد الترحيل
  } catch (err) {
    swal(err.response?.data?.message || "حدث خطأ أثناء الترحيل");
  }
  setPosting(false);
};

  return (
         <div className='container-fluid'>

 <Row>
                <Col lg="12">
                  <div className="card p-4">
                  <div className="card-body p-0">
                      <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">   
      
                       <div className="tbl-caption">
                       <h4 className="heading ms-3">إضافة رصيد افتتاحي</h4>
 
                              </div>  
                              </div>   </div>    

<div className="mb-3">
  <button
    type="button"
    className="btn btn-warning btn-sm me-2"
    onClick={handlePostOpeningBalances}
    disabled={posting}
  >
    {posting ? "جارٍ الترحيل..." : "ترحيل الأرصدة الافتتاحية"}
  </button>

  <button
    type="submit"
    disabled={loading}
    className="btn btn-primary btn-sm"
  >
    {loading ? "جارٍ الإضافة..." : "حفظ الرصيد"}
  </button>
</div>

      {/* الفورم في صف واحد */}
      <form
        onSubmit={handleSubmit}
        className="row  "
      >
                <div className="col-md-3">

        <div className="d-flex ">
          <label>الحساب</label>
          <select
            name="account_id"
            value={formData.account_id}
            onChange={handleChange}
            required
            className="form-control mx-2"
          >
            <option value="">-- اختر الحساب --</option>
            {accounts.map((acc) => (
              <option key={acc.AccountID} value={acc.AccountID}>
                {acc.AccountName} ({acc.AccountType})
              </option>
            ))}
          </select>
        </div>
</div>
          <div className="col-md-3">

        <div className="d-flex   ">
          <label style={{whiteSpace:'nowrap'}}>الحساب الموازن</label>
          <select
            name="counter_account_id"
            value={formData.counter_account_id}
            onChange={handleChange}
            required
            className="form-control mx-2"
          >
            <option value="">-- اختر الحساب الموازن --</option>
            {accounts.map((acc) => (
              <option key={acc.AccountID} value={acc.AccountID}>
                {acc.AccountName} ({acc.AccountType})
              </option>
            ))}
          </select>
        </div>
</div>
          <div className="col-md-3">

        <div className="d-flex  ">
          <label>المبلغ</label>
          <input
            type="number"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
            required
            className="form-control mx-2"
          />
        </div>
</div>     
           <div className="col-md-3">

        <div className="d-flex ">
          <label>الوصف</label>
          <input
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="form-control mx-2"
          />
        </div> 
</div>
        <div>
          <button
            type="submit"
            disabled={loading}
            className="btn  btn-sm btn-primary m-3"
          >
            {loading ? "جارٍ الإضافة..." : "حفظ الرصيد"}
          </button>
        </div>
      </form>

      {/* جدول بعرض كامل الصفحة */}
      <h4 className="text-md   mb-2">الأرصدة الحالية</h4>
      <div className="overflow-x-auto">
         <table className="table table-bordered table-striped">
  <thead className="table-dark text-center">
            <tr className="bg-gray-200">
              <th className="border px-2 py-1">الحساب</th>
               <th className="border px-2 py-1">المبلغ</th>
              <th className="border px-2 py-1">الوصف</th>
            </tr>
          </thead>
          <tbody>
            {balances.map((bal) => (
              <tr key={bal.id}>
                <td className="border px-2 py-1">{bal.account.AccountName}</td>
                 
                <td className="border px-2 py-1">{bal.balance}</td>
<td className="border px-2 py-1">
  {bal.type === 'Debit' ? 'مدين' : 'دائن'}
</td>              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    </Col>
</Row> </div> );
}
